import omit from 'lodash/omit';
import React from 'react';
import { CardActions as EdsCardActions } from '@hedtech/react-design-system/core/es/Card';
const CardActions = (props) => {
    const { children } = props;
    return (React.createElement(EdsCardActions, Object.assign({}, omit(props, ['children'])), children));
};
export default CardActions;
